export default "__VITE_ASSET__df7e86e5__"